import PropTypes from 'prop-types'
import styled, { theme, prop } from '@nobia/zeus-components/lib/styled'
import settings from '@nobia/zeus-components/lib/settings'
import React, { Suspense, useState, useContext } from 'react'
import { pure } from 'recompose'

import ImageUi from '../image/Image'
import Loader from '../loader/Loader'
import PriceBand from '../priceBand/PriceBand'
import Colors from '../colors/Colors'
import { formatPrice, getCabinetPrice, checkHideFlatPack } from '../cards/utils'
import { useTranslation } from '../../utils/useTranslation'
import Context from '../../app/context'
import CabinetCard from './CabinetCard'
import InstallationCard from './InstallationCard'

const Select = styled.select`
  background-image: ${({ backgroundUrl }) => `url(${backgroundUrl})`};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-repeat: no-repeat, repeat;
  background-position: right 6px top 50%, 0 0;
  background-size: 1.66em auto, 100%;
  padding: 10px;
  font-size: 16px;
  font-family: ${prop('theme.font.select.fontFamily')};
  font-weight: ${prop('theme.font.select.fontWeight')};
  border-radius: 3px;
  border: 1px solid ${prop('theme.input.borderColor')};
  min-width: 220px;
  margin: 0;
  max-width: 400px;
  background-color: ${prop('theme.input.select.bgColor')};
  color: ${theme('colors.primary')};
  width: 75%;
  margin: 0 10px 0 0;
  opacity: 1;
  cursor: pointer;
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    width: 60%;
    margin: 30px 20px;
  }
  @media (min-width: ${prop('theme.body.tabletWidth')}) and (max-width: ${prop(
  'theme.body.desktopWidth'
)}) {
    margin-left: ${prop('theme.input.mobile.marginLeft')};
  }
`

const SelectPlaceholder = styled.div`
  padding: 10px;
  font-size: 16px;
  font-family: ${prop('theme.font.select.fontFamily')};
  font-weight: ${prop('theme.font.select.fontWeight')};
  border-radius: 3px;
  border: 1px solid ${prop('theme.input.borderColor')};
  min-width: 220px;
  margin: 0;
  max-width: 400px;
  background-color: ${prop('theme.input.select.bgColor')};
  color: ${theme('colors.primary')};
  width: 75%;
  margin: 0 10px 0 0;
  opacity: 1;
  cursor: pointer;
  @media (min-width: ${prop('theme.body.desktopWidth')}) {
    width: 60%;
    margin: 30px 20px;
  }
  @media (min-width: ${prop('theme.body.tabletWidth')}) and (max-width: ${prop(
  'theme.body.desktopWidth'
)}) {
    margin-left: ${prop('theme.input.mobile.marginLeft')};
  }
`

const Button = styled.button`
  background-color: ${theme('colors.white')};
  min-width: 300px;
  width: 300px;
  border-radius: 6px;
  margin: 10px;
  padding: 0;
  scroll-snap-align: center;
  transition: opacity 150ms ease;
  border: 2px solid ${(p) => p.theme.card.border[p.color]};
  opacity: ${(p) => (p.selected ? 1 : 0.75)};
  display: flex;
  flex-direction: column;
  align-items: center;
  :hover {
    opacity: 1;
  }
`
const ButtonInner = styled.button`
  background-color: ${theme('colors.white')};
  min-width: 40px;
  width: 40px;
  margin: 10px;
  padding: 0;
  scroll-snap-align: center;
  transition: opacity 150ms ease;
  opacity: ${(p) => (p.selected ? 1 : 0.75)};
  font-size: 30px;
  :hover {
    opacity: 1;
  }
`
const ButtonWrap = styled.div`
  display: inline-block;
`
const Info = styled.div`
  text-align: ${(p) => p.textAlign || 'center'};
  padding: ${prop('theme.body.padding')};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledInfo = styled(Info)`
  justify-content: space-between;
`

const ImageWrapper = styled.div`
  overflow: hidden;
  width: 100%;
  height: 200px;
  background-color: ${theme('colors.white')};
  border-radius: 3px 3px 0 0;
`
const H4 = styled.h4`
  margin: 0;
`
const UnitsTitle = styled(H4)``
const Strong = styled.strong`
  font-weight: 500;
`
const Description = styled.p`
  margin: 10px 0;
  ${() =>
    settings.brand === 'invita' &&
    `
      font-weight: 250;
      line-height: 19px;
    `}
`
const Price = styled.strong`
  font-family: ${prop('theme.font.paragraph.fontFamily')};
  font-weight: 500;
  font-size: 16px;
  margin-top: auto;
  color: ${theme('colors.primary')};
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;
`
const Column = styled.div``
const Image = styled(ImageUi)`
  min-height: 200px;
  width: 100%;
`
const Card = ({
  id,
  section,
  type,
  image,
  imageSrc,
  images,
  title,
  description,
  cardType,
  units,
  priceBand,
  colors,
  price,
  priceText,
  prices,
  prebuiltPrices,
  handlelessPrices,
  selected,
  selection,
  filterWorktops,
  ifcAvailable,
  showHandleSelection,
  onSelect,
  defmessage,
  appliances,
  sinks,
  handles,
}) => {
  const { t, country } = useTranslation()

  const savedOption =
    selected && selection?.[section]?.option
      ? selection[section].option
      : null

  const [applianceOption, setapplianceOption] = useState(
    savedOption && appliances.some(a => a.key === savedOption.key)
      ? savedOption
      : appliances[0]
  )
  const [sinkOption, setsinkOption] = useState(
    savedOption && sinks.some(s => s.key === savedOption.key)
      ? savedOption
      : sinks[0]
  )
  const [handleOption, setHandleOption] = useState(
    savedOption && handles.some(h => h.key === savedOption.key)
      ? savedOption
      : handles[0]
  )
  const card = {
    id,
    section,
    type,
    image,
    imageSrc,
    images,
    title,
    description,
    cardType,
    units,
    priceBand,
    colors,
    price,
    prices,
    prebuiltPrices,
    handlelessPrices,
    selected,
    filterWorktops,
    ifcAvailable,
    showHandleSelection,
    defmessage,
    handles,
    option:
      type === 'sinks'
        ? sinkOption
        : type === 'appliances'
          ? applianceOption
          : type === 'range' && showHandleSelection
            ? handleOption
            : undefined,
  }
  const color = selected ? 'selected' : 'default'

  const { storage, setStorage } = useContext(Context)

  /* eslint-disable */
  const setSelectedApplianceOption = (event) => {
    event.stopPropagation()
    const option = appliances.find(
      (option) => option.value === event.target.value
    )
    setapplianceOption(option)
    onSelect({ ...card, option }, true)
  }

  const setSelectedSinkOption = (event) => {
    event.stopPropagation()
    const option = sinks.find((option) => option.value === event.target.value)
    setsinkOption(option)
    onSelect({ ...card, option }, true)
  }

  const setSelectedRangeHandleOption = (event) => {
    event.stopPropagation()
    const option = handles.find((option) => option.value === event.target.value)
    setHandleOption(option)
    onSelect({ ...card, option }, true)
  }
  /* eslint-enable */

  const calculateStoragePrice = () => {
    for (let i = 0; i < storage.cards.length; i += 1) {
      if (card.title === storage.cards[i].title) {
        return storage.cards[i].amount
          ? storage.cards[i].amount * storage.cards[i].price
          : storage.cards[i].price
      }
    }
    return 0
  }

  const getStorageAmount = () => {
    for (let i = 0; i < storage.cards.length; i += 1) {
      if (card.title === storage.cards[i].title) {
        return storage.cards[i].amount
      }
    }
    return 0
  }

  const raisePrice = (e) => {
    const tmpStorage = storage
    for (let i = 0; i < storage.cards.length; i += 1) {
      if (card.title === storage.cards[i].title) {
        tmpStorage.cards[i].amount += 1
        setStorage(tmpStorage)
      }
    }
    e.preventDefault()
    e.stopPropagation()
    onSelect(card, false)
  }

  const decreasePrice = (e) => {
    const tmpStorage = storage
    for (let i = 0; i < storage.cards.length; i += 1) {
      if (card.title === storage.cards[i].title) {
        if (tmpStorage.cards[i].amount === 0) return
        tmpStorage.cards[i].amount -= 1
        setStorage(tmpStorage)
      }
    }
    e.preventDefault()
    e.stopPropagation()
    onSelect(card, false)
  }

  const pickSelect = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }
  const setTitle = (cardTitle) => {
    if (cardTitle === 'Laminaatti (Nordic Nature)') {
      return 'Laminaatti'
    } else if (cardTitle === 'Kivitaso (Nordic Nature)') {
      return 'Kivitaso'
    } else if (cardTitle === 'Laminat (Basic)') {
      return 'Laminat'
    }
    return cardTitle
  }
  const getAppliancePrice = () => {
    if (card.prices === null) return 0
    return card.prices[0][applianceOption.key]
  }
  const getSinkPrice = () => {
    if (card.prices === null) return 0
    return card.prices[0][sinkOption.key]
  }
  const getSinkImage = () => {
    if (card.images === null) return 0
    return card.images[0][sinkOption.key]
  }
  if (section === 'range') {
    return (
      <Button color={color} onClick={() => onSelect(card, true)}>
        <ImageWrapper>
          <Image publicId={image} width={300} height={200} />
        </ImageWrapper>
        <StyledInfo textAlign="left">
          <Row>
            <Column>
              <H4>{title}</H4>
              {colors && (
                <Suspense fallback={<Loader />}>
                  <Colors colors={colors} />
                </Suspense>
              )}
            </Column>
            {priceBand && (
              <Column>
                <PriceBand count={priceBand} />
              </Column>
            )}
          </Row>
          <Description>{description}</Description>
          <Row>
            {showHandleSelection && (
              <>
                {handles.length > 1 ? (
                  <Select
                    onClick={pickSelect}
                    onChange={setSelectedRangeHandleOption}
                    backgroundUrl={t('app.components.summary.icon-url')}
                    value={handleOption?.value}
                  >
                    {handles.map(({ value, key }) => (
                      <option key={`${key}-option`}>{value}</option>
                    ))}
                  </Select>
                ) : (
                  <SelectPlaceholder>
                    {handles.map(({ value, key }) => (
                      <div key={`${key}-option`}>{value}</div>
                    ))}
                  </SelectPlaceholder>
                )}
              </>
            )}
          </Row>
        </StyledInfo>
      </Button>
    )
  }
  if (section === 'units') {
    return (
      <Button color={color} onClick={() => onSelect(card, true)}>
        <ImageWrapper>
          <Image publicId={image} width={300} height={200} />
        </ImageWrapper>
        <Info>
          <UnitsTitle>{title}</UnitsTitle>
          {units && (
            <Strong>
              {units} {t('app.components.card.units')}
            </Strong>
          )}
          <Description>{description}</Description>
          <Price>{priceText}</Price>
        </Info>
      </Button>
    )
  }
  if (section === 'simple') {
    return (
      <Button color={color} onClick={() => onSelect(card, true)}>
        {image && (
          <ImageWrapper>
            <Image publicId={image} width={300} height={200} keepDefaultScale />
          </ImageWrapper>
        )}
        <Info>
          <H4>{setTitle(title)}</H4>
          <Description>{description}</Description>
          {priceText !== '0 kr' ? (
            <Price>{priceText}</Price>
          ) : (
            <Price>{defmessage}</Price>
          )}
        </Info>
      </Button>
    )
  }
  if (section === 'installation') {
    return (
      <InstallationCard
        card={card}
        selection={selection}
        priceText={priceText}
        defmessage={defmessage}
        selected={selected}
        onSelect={onSelect}
      />
    )
  }
  if (section === 'cabinet') {
    const isFlatPack = card.type === 'flat-pack'
    const isHideFlatPack = checkHideFlatPack(selection)
    const cabinetPrice = getCabinetPrice(card, selection)
    const formattedPrice = formatPrice({
      price: cabinetPrice,
      country,
      startingText: t('app.components.card.from'),
    })

    if (isHideFlatPack && isFlatPack) {
      return null
    }

    return (
      <CabinetCard
        card={card}
        priceText={formattedPrice}
        selected={selected}
        onSelect={onSelect}
      />
    )
  }
  if (section === 'storage') {
    return (
      <Button color={color} onClick={() => onSelect(card, false)}>
        {image && (
          <ImageWrapper>
            <Image publicId={image} width={300} height={200} keepDefaultScale />
          </ImageWrapper>
        )}
        <Info>
          <H4>{setTitle(title)}</H4>
          <Description>{description}</Description>

          {priceText !== '0 kr' ? (
            <Price>
              {t('app.components.card.from')}{' '}
              {formatPrice({ price: calculateStoragePrice(), country })}
            </Price>
          ) : (
            <Price>{defmessage}</Price>
          )}
        </Info>
        <ButtonWrap>
          <ButtonInner onClick={(e) => decreasePrice(e)}>-</ButtonInner>
          {getStorageAmount()}
          <ButtonInner onClick={(e) => raisePrice(e)}>+</ButtonInner>
        </ButtonWrap>
      </Button>
    )
  }
  if (section === 'appliances') {
    return (
      <Button color={color} onClick={() => onSelect(card, true)}>
        {image && (
          <ImageWrapper>
            <Image publicId={image} width={300} height={200} keepDefaultScale />
          </ImageWrapper>
        )}
        <Info>
          <H4>{setTitle(title)}</H4>
          <Description>{description}</Description>
          {title !== 'No appliances' && (
            <Select
              onClick={pickSelect}
              onChange={setSelectedApplianceOption}
              backgroundUrl={t('app.components.summary.icon-url')}
              value={applianceOption?.value}
            >
              {appliances.map(({ value, key }) => (
                <option key={`${key}-option`}>{value}</option>
              ))}
            </Select>
          )}
          {priceText !== '0 kr' ? (
            <Price>
              {t('app.components.card.from')}{' '}
              {formatPrice({ price: getAppliancePrice(), country })}
            </Price>
          ) : (
            <Price>{defmessage}</Price>
          )}
        </Info>
      </Button>
    )
  }
  if (section === 'sinks') {
    return (
      <Button color={color} onClick={() => onSelect(card, true)}>
        <ImageWrapper>
          <Image publicId={getSinkImage()} width={300} height={200} keepDefaultScale />
        </ImageWrapper>
        <Info>
          <H4>{setTitle(title)}</H4>
          <Description>{description}</Description>
          <Select
            onClick={pickSelect}
            onChange={setSelectedSinkOption}
            backgroundUrl={t('app.components.summary.icon-url')}
            value={sinkOption?.value}
          >
            {sinks.map(({ value, key }) => (
              <option key={`${key}-option`}>{value}</option>
            ))}
          </Select>
          {priceText !== '0 kr' ? (
            <Price>
              {t('app.components.card.from')}{' '}
              {formatPrice({ price: getSinkPrice(), country })}
            </Price>
          ) : (
            <Price>{defmessage}</Price>
          )}
        </Info>
      </Button>
    )
  }
  return null
}
const PureCard = pure((props) => <Card {...props} />)
Card.defaultProps = {
  image: null,
  imageSrc: null,
  images: [],
  description: null,
  cardType: null,
  units: null,
  priceBand: null,
  colors: null,
  price: null,
  priceText: null,
  prices: null,
  filterWorktops: null,
  defmessage: null,
  ifcAvailable: null,
  showHandleSelection: false,
  selection: null,
  appliances: [],
  sinks: [],
  handles: [],
}
Card.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageSrc: PropTypes.string,
  images: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  cardType: PropTypes.number,
  units: PropTypes.number,
  priceBand: PropTypes.number,
  colors: PropTypes.arrayOf(PropTypes.shape({})),
  price: PropTypes.number,
  priceText: PropTypes.string,
  defmessage: PropTypes.string,
  prices: PropTypes.shape({}),
  prebuiltPrices: PropTypes.shape({}),
  handlelessPrices: PropTypes.shape({}),
  selected: PropTypes.bool.isRequired,
  selection: PropTypes.shape({}),
  ifcAvailable: PropTypes.bool,
  showHandleSelection: PropTypes.bool,
  filterWorktops: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func.isRequired,
  appliances: PropTypes.arrayOf(PropTypes.shape({})),
  sinks: PropTypes.arrayOf(PropTypes.shape({})),
  handles: PropTypes.arrayOf(PropTypes.shape({})),
}
export default PureCard
